import React, { Component } from "react";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";

class SendChatTranscriptForm extends Component {
  constructor() {
    super();
    this.trancriptRef = React.createRef();
    this.messageRef = React.createRef();
    this.state = {
      value: null,
      showError: false,
    };
  }
  emailPlaceholderValue = "Please Enter Email";

  render() {
    return (
      <div ref={this.trancriptRef} className="s360-chat-full-screen-container">
        <div className="s360-chat-transcript-email-form-container">
          <div
            className="s360-chat-transcript-default-close-icon"
            onClick={this.props.onClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24.674 24.668"
            >
              <defs></defs>
              <path
                class="a"
                style={this.closeIconStyle()}
                d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z"
                transform="translate(-11.285 -11.289)"
              />
            </svg>
          </div>
          <div
            className="s360-chat-transcript-email-form-textbox-container"
            style={this.formInputBoxContainerStyle()}
          >
            <input
              type="text"
              ref={this.messageRef}
              className="s360-initial-form-textbox-input"
              onClick={this.onClickInput}
              onChange={this.handleChange}
              onBlur={this.onInputOut}
              placeholder={this.emailPlaceholderValue}
              style={this.formInputBoxStyle()}
            />
          </div>

          <div className={"s360-chat-transcript-send-button-container"}>
            <input
              className="s360-initial-form-start-button"
              type="button"
              value="Send"
              onClick={this.onSend}
              style={this.buttonStyle()}
            />
            {this.state.showError === true ? (
              <p
                style={{
                  color: "red",
                  marginTop: "-22%",
                  marginLeft: "-59%",
                  fontSize: "11px",
                }}
              >
                Enter Valid Email
              </p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  handleChange = () => {
    this.setState({
      showError: false,
    });
  };

  onSend = () => {
    let emailId = this.messageRef.current.value;
    console.log(emailId);
    if (!emailId.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      this.setState({
        showError: true,
      });
    } else this.props.onSendChatTranscript(emailId);
    //console.log(this.state.showError,'showError')
  };

  buttonStyle = () => {
    return {
      background: this.props.config.designDetails.selectionButtonColor,
      color: this.props.config.designDetails.selectionButtonTextColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
      border:
        this.state.showError === true ? "1px solid red" : "1px solid black",
    };
  };

  formInputBoxContainerStyle = () => {
    return {
      // fill: this.props.config.designDetails.headerColor,
      borderColor: this.state.showError
        ? "red"
        : this.props.config.designDetails.inputBorderColor,
      borderRadius: '8px'
    };
  };

  closeIconStyle = () => {
    return {
      color: isNullOrUndefined(this.props.config.designDetails.closeIconColor)
        ? "black"
        : this.props.config.designDetails.closeIconColor,
    };
  };

  formInputBoxStyle = () => {
    return {
      borderColor: this.props.config.designDetails.headerColor,
      color: isNullOrUndefined(
        this.props.config.designDetails.formInputTextColor
      )
        ? "black"
        : this.props.config.designDetails.formInputTextColor,
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
      padding: "0px"
    };
  };

  onClickInput = (e) => {
    if (e.target.value === this.emailPlaceholderValue) {
      this.messageRef.current.value = "";
    }
  };

  onInputOut = (e) => {
    if (!e.target.value || !e.target.value.trim) {
      this.messageRef.current.value = this.emailPlaceholderValue;
    }
  };

  value = () => {
    let aValue = {};
    aValue[this.emailPlaceholderValue] = this.messageRef.current.value;
    return aValue;
  };

  validate = (e) => {
    let val = this.state.email;
    //let regex='/\S+@\S+\.\S+/';
    if (val.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      this.setState({
        showError: true,
      });
    }
  };
}

export default SendChatTranscriptForm;
